import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  footer: {
    background: theme.palette.purple,
    width: '100vw',
    position:'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',

    '&:before': {
      width: '100%',
      height: '2rem',
      content: '""',
      position: 'absolute',
      clipPath: 'polygon(0 0%, 100% 0%, 100% 100%, 100% 100%)',
      backgroundSize: 'cover',
      backgroundColor: theme.palette.yellow,
      top: '-0.063rem'
    }
  },
  footerContent: {
    paddingTop: '5rem',
    paddingBottom: '3rem',
    maxWidth: theme.limits.max,
    margin: '0 auto',
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      paddingTop: '2.5625rem',
      alignItems: 'center',
      display: 'table',
      width: '100%'
    },

    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      paddingTop: '4.5625rem'
    }
  },
  a: {
    border: '0.125rem solid #0000FF',
    backgroundColor: '#6495ED'
  },
  footerImages: {
    pointerEvents: 'none',
    position: 'absolute',
    width: '100%',
    maxWidth: theme.limits.max,
      top: '0',
    zIndex: 2,
  },
  footerImagesLime: {
    display: 'none',
    float: 'right',
    marginTop: '-1.5rem',

    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      display: 'inline',
      marginRight: '6%'
    },

    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      display: 'inline',
      marginRight: '20%',
      marginTop: '-2.5rem',
    },

    [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
      marginRight: '5%',
    }
  },
  footerImagesNut: {
    display: 'none',

    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      display: 'inline',
      marginLeft: '29%',
      marginTop: '-3.5rem',
    },

    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      display: 'inline',
      marginLeft: '10%',
      marginTop: '8rem',
    },

    [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
      marginLeft: '24%',
    }
  },
  footerImagesTaki: {
    position: 'relative',
    float: 'right',
    marginRight: '3rem',
    marginTop: '-3rem',

    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      position: 'absolute',
      float: 'none',
      display: 'inline',
      marginLeft: '1rem',
      marginTop: '-2.7rem'
    },

    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      marginLeft: '11rem',
      marginTop: '-3.5rem',
    }
  },
  socialIconsList: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    maxWidth: '23.4375rem',
    margin: '0 auto',
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      maxWidth: 'unset',
      margin: 'unset',
      justifyContent: 'center',
      float: 'none',
      padding: '2rem 0 2.8125rem 0'
    },

    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      paddingTop: '0',
      justifyContent: 'left',
      float: 'left',
    }
  },
  socialIconsListItem: {
    listStyle: "none",
    display: "inline-flex",
  },
  socialIcons: {
    margin: '0 auto !important',
    border: '0.313rem solid transparent',
    borderBottomWidth: '0.0625rem',

    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      margin: '0 2.5rem 0 0 !important',
      '&:last-child': {
        marginRight: '0 !important',
      },
      '&:first-child': {
        marginLeft: '2.0625rem !important',
      },
    },

    '&:focus': {
            backgroundColor: theme.palette.darkPurple,
      outline: 'none'
        },
  },
  generalLinksContainer: {
    display: 'grid',

    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      display: 'block'
    }
  },
  generalLinkslist: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    textAlign: 'center',
    padding: 0,
    marginTop: '3rem',
    maxWidth: '49.125rem',
    float: 'none',

    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      flexDirection: 'row',
      margin: '0 auto',
    },

    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      float: 'right'
    }
  },
  generallinks: {
    maxWidth: '12.5rem',
    margin: '0.75rem auto',
    listStyleType: 'none',

    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      maxWidth: '100%',
      padding: '0 0.938rem 0',

      '&:first-child': {
        paddingLeft: '3.4375rem'
      }
    }
  },
  svg: {
    width: '2.188rem',
    height: '2.188rem',
    color: theme.palette.white,
    transition: '.1s ease-in-out',
    '&:hover': {
      transform: 'scale(1.3)'
    }
  }
}));
